import { moveItemInArray } from 'utils/helperFunctions';
import { CombineTypeAnswer, mappingSelectType } from 'views/pages/questionBank/questionAdd/types';
import { IUploadExcelCallApi } from '../surveyAdd/ListOfMembers/Component/Excel/UploadExcelModal';
import {
  I360MemberList,
  IGetSurveyMemberGroupFilter,
  IGetSurveyMemberSearch,
  SurveyMemberListSelectedType,
  DdlGroupDivision,
  DdlGroupRestaurant,
} from '../surveyAdd/ListOfMembers/types';
import {
  IGetSurveyInfomation,
  IListOfBonusCode,
  TSelectType,
  IMemberGroupInfo,
  ILoadingMemberGroupInfo,
  TActionChangeListMemberGroup,
  IDDLCategory,
  IParamFilterEvaluatedQuestionProps,
} from '../surveyAdd/type';
import { ISectionGroup, ISurveyDataSave } from '../type';
import { ActionTypes } from './actions';
import { InitialStateType, SurveyConst } from './surveyContext';
import {
  DdlRegion,
  DdlQuestionUnit,
  DdlQuestionDepartment,
  DdlQuestionPosition,
  DdlLevel,
} from 'views/pages/questionBank/type';

type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined ? { type: Key } : { type: Key; payload: M[Key] };
};

type Payload = {
  [ActionTypes.OPEN_MODAL_USER_INFO]: undefined;
  [ActionTypes.CLOSE_MODAL_USER_INFO]: undefined;
  [ActionTypes.OPEN_MODAL_ADDING_QUESTION]: undefined;
  [ActionTypes.CLOSE_MODAL_ADDING_QUESTION]: undefined;
  [ActionTypes.OPEN_MODAL_ADDING_QUESTION_USER_EVALUATED]: undefined;
  [ActionTypes.CLOSE_MODAL_ADDING_QUESTION_USER_EVALUATED]: undefined;
  [ActionTypes.OPEN_MODAL_LOCK_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_LOCK_SURVEY]: undefined;
  [ActionTypes.OPEN_MODAL_ADDING_SECTION]: undefined;
  [ActionTypes.CLOSE_MODAL_ADDING_SECTION]: undefined;
  [ActionTypes.OPEN_MODAL_CONFIRM]: undefined;
  [ActionTypes.CLOSE_MODAL_CONFIRM]: undefined;
  [ActionTypes.OPEN_MODAL_PUBLISH_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_PUBLISH_SURVEY]: undefined;
  [ActionTypes.OPEN_MODAL_DRAFT_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_DRAFT_SURVEY]: undefined;
  [ActionTypes.OPEN_MODAL_UPLOAD_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_UPLOAD_SURVEY]: undefined;
  [ActionTypes.OPEN_MODAL_CONFIRM_SHOW_SURVEY_RESULTS]: undefined;
  [ActionTypes.CLOSE_MODAL_CONFIRM_SHOW_SURVEY_RESULTS]: undefined;

  [ActionTypes.OPEN_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY]: undefined;

  [ActionTypes.OPEN_MODAL_CONFIRM_EXIT_EDIT_SURVEY]: undefined;
  [ActionTypes.CLOSE_MODAL_CONFIRM_EXIT_EDIT_SURVEY]: undefined;

  [ActionTypes.OPEN_MODAL_UPLOAD_EVALUATED_PEOPLE_360]: undefined;
  [ActionTypes.CLOSE_MODAL_UPLOAD_EVALUATED_PEOPLE_360]: undefined;

  [ActionTypes.EDIT_EMPLOYEE_INFO]: {
    infoDisplayed: { [key: string]: boolean };
    type: SurveyConst.CUSTOMER_INFO | SurveyConst.EMPLOYEE_INFO;
  };
  [ActionTypes.SWITCH_INFO_PERSON_DISPLAYED]: {
    isPersonInfoDisplayed: boolean;
  };
  [ActionTypes.ADD_QUESTION_INTO_QUESTIONLIST]: {
    question: CombineTypeAnswer;
  };
  [ActionTypes.ADD_QUESTION_INTO_FIRST_QUESTIONLIST]: {
    question: CombineTypeAnswer;
  };
  [ActionTypes.ADD_GROUP_QUESTIONS]: {
    sectionGroup: ISectionGroup;
  };
  [ActionTypes.MOVE_SECTION_IN_GROUP]: {
    moveObjId: string;
    moveDirection: 'move_up' | 'move_down';
  };
  [ActionTypes.MOVE_QUESTION_IN_GROUP]: {
    sourceID: string;
    questionID: CombineTypeAnswer['questionID'];
    moveDirection: 'move_up' | 'move_down';
  };
  [ActionTypes.REMOVE_QUESTION_IN_GROUP]: {
    sourceID: string;
    questionID: CombineTypeAnswer['questionID'];
  };
  [ActionTypes.UPDATE_QUESTION_EVALUATED_IN_GROUP]: {
    sourceID: string;
    dataQuestionEvaluated: any;
  };
  [ActionTypes.REMOVE_SECTION_IN_GROUP]: {
    sourceID: string;
  };
  [ActionTypes.SET_SELECT_QUESTION]: {
    questionID: string;
  };
  [ActionTypes.SET_SELECT_SECTION]: {
    sectionID: string;
  };
  [ActionTypes.EDIT_SELECT_QUESTION_IN_GROUP]: {
    questionID: string;
    sectionID: string;
    newData: CombineTypeAnswer;
  };
  [ActionTypes.SAVE_ALL_TABS_BEGIN]: undefined;
  [ActionTypes.SAVE_ALL_TABS_END]: undefined;
  [ActionTypes.SET_SURVEY_TAB_1_INFORMATION]: {
    surveyInformation: IGetSurveyInfomation;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERSEARCH]: {
    surveyMemberSearch: IGetSurveyMemberSearch;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBER_GROUP_FILTER]: {
    surveyMemberGroupFilter: IGetSurveyMemberGroupFilter;
  };

  [ActionTypes.SET_SURVEY_TAB_3_MEMBER_OBJECTGROUP]: {
    memberObjectGroup: number;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST]: {
    surveyMemberList: any;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL]: {
    surveyMemberListAll: any;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_360]: {
    surveyMemberList360: any;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL_360]: {
    surveyMemberListAll360: any;
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_SELECTED]: {
    surveyMemberListSelected: SurveyMemberListSelectedType[];
  };
  [ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_CHOSEN]: {
    surveyMemberListChosen: any[];
  };
  [ActionTypes.HANDLE_CHANGE_TABS]: {
    typeOfTab: TSelectType;
  };
  [ActionTypes.INIT_SURVEY]: {
    type: SurveyConst.START_INIT | SurveyConst.END_INIT;
  };
  [ActionTypes.SET_LOADING]: {
    type: SurveyConst.LOADING_ON | SurveyConst.LOADING_OFF;
  };
  [ActionTypes.SET_DISABLED_SURVEY_EDIT]: {
    isDisabledSurveyEdit: boolean;
  };
  [ActionTypes.SET_IS_VIEW_SURVEY]: {
    isViewSurvey: boolean;
  };
  [ActionTypes.SET_SKIP_MODAL_CONFIRM]: {
    skipModalConfirm: boolean;
  };
  [ActionTypes.SET_SAVE_TAB]: {
    previousTab: TSelectType;
  };
  [ActionTypes.SET_USER_CHANGE_MODAL_ADD_QUESTION]: {
    isUserChangeModalAddQuestion: boolean;
  };
  [ActionTypes.SET_LIST_OF_BONUS_CODE_TAB_1_INFORMATION]: {
    listOfBonusCode: IUploadExcelCallApi;
  };
  [ActionTypes.SET_INFO_PEOPLE]: {
    infoPeople: string;
  };
  [ActionTypes.SET_DISABLED_SURVEY_360]: {
    disabledSurvey360: boolean;
  };
  [ActionTypes.SET_SURVEY_TYPE_FORM]: {
    surveyTypeForm: number;
  };
  [ActionTypes.SET_QUESTION_ID_ARR_COPY]: {
    questionIDArrCopy: string[];
  };
  [ActionTypes.SET_SURVEY_DATA_SAVE]: {
    surveyDataSaveTab: ISurveyDataSave;
  };
  [ActionTypes.SET_EVALUATED_QUESTION_EXIST]: {
    isEvaluatedQuestionExist: boolean;
  };
  [ActionTypes.SET_IS_COPY_SURVEY]: {
    isCopySurvey: boolean;
  };
  [ActionTypes.SET_QUESTION_ORDER]: {
    questionOrder: string;
  };
  [ActionTypes.SET_MEMBER_GROUP_INFO]: {
    memberGroupInfo: IMemberGroupInfo;
  };
  [ActionTypes.SET_LOADING_MEMBER_GROUP_INFO]: {
    loadingMemberGroupInfo: ILoadingMemberGroupInfo;
  };
  [ActionTypes.SET_TYPE_ACTION_CHANGE_LIST_MEMBER_GROUP]: {
    typeActionChangeListMemberGroup: TActionChangeListMemberGroup;
  };
  [ActionTypes.SET_CURRENT_VALUE_INFORMATION_TAB]: {
    surveyInformation: IGetSurveyInfomation;
  };
  [ActionTypes.SET_DDL_REGION_MEMBER_GROUP_BACKUP]: {
    ddlRegionGroupBackup: DdlRegion[];
  };
  [ActionTypes.SET_DDL_UNIT_MEMBER_GROUP_BACKUP]: {
    ddlUnitGroupBackup: DdlQuestionUnit[];
  };
  [ActionTypes.SET_DDL_DEPARTMENT_MEMBER_GROUP_BACKUP]: {
    ddlDepartmentGroupBackup: DdlQuestionDepartment[];
  };
  [ActionTypes.SET_DDL_DIVISION_MEMBER_GROUP_BACKUP]: {
    ddlDivisionGroupBackup: DdlGroupDivision[];
  };
  [ActionTypes.SET_DDL_RESTAURANT_MEMBER_GROUP_BACKUP]: {
    ddlRestaurantGroupBackup: DdlGroupRestaurant[];
  };
  [ActionTypes.SET_DDL_LEVEL_MEMBER_GROUP_BACKUP]: {
    ddlLevelGroupBackup: DdlLevel[];
  };
  [ActionTypes.SET_DDL_POSITION_MEMBER_GROUP_BACKUP]: {
    ddlPositionGroupBackup: DdlQuestionPosition[];
  };
  [ActionTypes.SET_LIST_STAFF_360]: {
    listStaff360: IDDLCategory[];
  };
  [ActionTypes.SET_FETCH_QUESTION_AFTER_UPLOAD_EXCEL]: {
    isFetchQuestionAfterUploadExcel: boolean;
  };
  [ActionTypes.SET_PARAM_FILTERS_EVALUATED_QUESTION]: {
    paramFiltersEvaluatedQuestion: IParamFilterEvaluatedQuestionProps;
  };
  [ActionTypes.SET_IS_FIRST_LOAD_TAB]: {
    isFirstLoadTab: { [x: string]: boolean };
  };
  [ActionTypes.SET_IS_MEMBER_LIST_360_CHANGED]: {
    isMemberList360Changed: boolean;
  };
};

type ActionsPayload = ActionMap<Payload>[keyof Payload];
type ActionReducer = ActionsPayload;

const reducer = (state: InitialStateType, action: ActionReducer) => {
  switch (action.type) {
    case ActionTypes.OPEN_MODAL_USER_INFO: {
      return {
        ...state,
        isOpenModalPerson: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_USER_INFO: {
      return {
        ...state,
        isOpenModalPerson: false,
      };
    }

    case ActionTypes.OPEN_MODAL_ADDING_QUESTION: {
      return {
        ...state,
        isOpenModalQuestion: true,
      };
    }

    case ActionTypes.OPEN_MODAL_ADDING_QUESTION_USER_EVALUATED: {
      return {
        ...state,
        isOpenModalQuestionUserEvaluated: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_ADDING_QUESTION_USER_EVALUATED: {
      return {
        ...state,
        isOpenModalQuestionUserEvaluated: false,
      };
    }

    case ActionTypes.OPEN_MODAL_LOCK_SURVEY: {
      return {
        ...state,
        isOpenModalLockSurvey: true,
      };
    }
    case ActionTypes.CLOSE_MODAL_LOCK_SURVEY: {
      return {
        ...state,
        isOpenModalLockSurvey: false,
      };
    }

    case ActionTypes.OPEN_MODAL_PUBLISH_SURVEY: {
      return {
        ...state,
        isOpenModalPublishSurvey: true,
      };
    }
    case ActionTypes.CLOSE_MODAL_PUBLISH_SURVEY: {
      return {
        ...state,
        isOpenModalPublishSurvey: false,
      };
    }

    case ActionTypes.OPEN_MODAL_DRAFT_SURVEY: {
      return {
        ...state,
        isOpenModalDraftSurvey: true,
      };
    }
    case ActionTypes.CLOSE_MODAL_DRAFT_SURVEY: {
      return {
        ...state,
        isOpenModalDraftSurvey: false,
      };
    }

    case ActionTypes.CLOSE_MODAL_ADDING_QUESTION: {
      return {
        ...state,
        isOpenModalQuestion: false,
      };
    }

    case ActionTypes.OPEN_MODAL_ADDING_SECTION: {
      return {
        ...state,
        isOpenModalSection: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_ADDING_SECTION: {
      return {
        ...state,
        isOpenModalSection: false,
      };
    }

    case ActionTypes.OPEN_MODAL_CONFIRM: {
      return {
        ...state,
        isOpenModalConfirm: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_CONFIRM: {
      return {
        ...state,
        isOpenModalConfirm: false,
      };
    }

    case ActionTypes.OPEN_MODAL_UPLOAD_SURVEY: {
      return {
        ...state,
        isOpenModalUploadSurvey: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_UPLOAD_SURVEY: {
      return {
        ...state,
        isOpenModalUploadSurvey: false,
      };
    }
    case ActionTypes.OPEN_MODAL_CONFIRM_SHOW_SURVEY_RESULTS: {
      return {
        ...state,
        isOpenModalConfirmShowSurveyResults: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_CONFIRM_SHOW_SURVEY_RESULTS: {
      return {
        ...state,
        isOpenModalConfirmShowSurveyResults: false,
      };
    }
    case ActionTypes.OPEN_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY: {
      return {
        ...state,
        isOpenModalDeleteQuestionUsedSurvey: true,
      };
    }
    case ActionTypes.CLOSE_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY: {
      return {
        ...state,
        isOpenModalDeleteQuestionUsedSurvey: false,
      };
    }

    case ActionTypes.OPEN_MODAL_CONFIRM_EXIT_EDIT_SURVEY: {
      return {
        ...state,
        isOpenModalConfirmExitEditSurvey: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_CONFIRM_EXIT_EDIT_SURVEY: {
      return {
        ...state,
        isOpenModalConfirmExitEditSurvey: false,
      };
    }

    case ActionTypes.OPEN_MODAL_UPLOAD_EVALUATED_PEOPLE_360: {
      return {
        ...state,
        isOpenModalUploadEvaluatedPeople360: true,
      };
    }

    case ActionTypes.CLOSE_MODAL_UPLOAD_EVALUATED_PEOPLE_360: {
      return {
        ...state,
        isOpenModalUploadEvaluatedPeople360: false,
      };
    }

    case ActionTypes.SET_DISABLED_SURVEY_EDIT: {
      return {
        ...state,
        isDisabledSurveyEdit: action.payload.isDisabledSurveyEdit,
      };
    }
    case ActionTypes.SET_IS_VIEW_SURVEY: {
      return {
        ...state,
        isViewSurvey: action.payload.isViewSurvey,
      };
    }
    case ActionTypes.SWITCH_INFO_PERSON_DISPLAYED: {
      return {
        ...state,
        isPersonInfoDisplayed: action.payload.isPersonInfoDisplayed,
      };
    }

    case ActionTypes.SET_SKIP_MODAL_CONFIRM: {
      return {
        ...state,
        skipModalConfirm: action.payload.skipModalConfirm,
      };
    }

    case ActionTypes.EDIT_EMPLOYEE_INFO: {
      if (action.payload.type === SurveyConst.EMPLOYEE_INFO) {
        return {
          ...state,
          employeeInfoDisplayed: {
            ...state.employeeInfoDisplayed,
            ...action.payload.infoDisplayed,
          },
        };
      }
      return {
        ...state,
        customerInfoDisplayed: {
          ...state.customerInfoDisplayed,
          ...action.payload.infoDisplayed,
        },
      };
    }

    case ActionTypes.ADD_QUESTION_INTO_QUESTIONLIST: {
      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [SurveyConst.INIT_GROUP_QUESTION]: {
            ...(state.groupQuestions as ISectionGroup)?.[SurveyConst.INIT_GROUP_QUESTION],
            question: [
              ...((state.groupQuestions as ISectionGroup)?.[SurveyConst.INIT_GROUP_QUESTION]
                .question ?? []),
              action.payload.question,
            ],
          },
        },
      };
    }

    case ActionTypes.ADD_QUESTION_INTO_FIRST_QUESTIONLIST: {
      const listQuestionExceptEvaluatedQuestion =
        state?.groupQuestions?.[SurveyConst.INIT_GROUP_QUESTION]?.question.filter(
          (y) => y.questionTypeID !== mappingSelectType.evaluated
        ) ?? [];
      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [SurveyConst.INIT_GROUP_QUESTION]: {
            ...(state.groupQuestions as ISectionGroup)?.[SurveyConst.INIT_GROUP_QUESTION],
            question: [action.payload.question, ...listQuestionExceptEvaluatedQuestion],
          },
        },
      };
    }

    case ActionTypes.ADD_GROUP_QUESTIONS: {
      return {
        ...state,
        groupQuestions: action.payload.sectionGroup,
      };
    }

    case ActionTypes.MOVE_SECTION_IN_GROUP: {
      const { moveObjId, moveDirection } = action.payload;
      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }
      const uuids = Object.keys(state.groupQuestions).slice(1);
      const currentIndex = uuids.indexOf(moveObjId);

      if (currentIndex === 0 && moveDirection === 'move_up') {
        return {
          ...state,
        };
      }

      if (currentIndex === uuids.length - 1 && moveDirection === 'move_down') {
        return {
          ...state,
        };
      }

      const movedUuid =
        moveDirection === 'move_up' ? uuids[currentIndex - 1] : uuids[currentIndex + 1];
      const temp = state.groupQuestions[movedUuid];

      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [movedUuid]: {
            ...state.groupQuestions[moveObjId],
            title: `Phần ${moveDirection === 'move_up' ? currentIndex : currentIndex + 2}`,
          },
          [moveObjId]: {
            ...temp,
            title: `Phần ${currentIndex + 1}`,
          },
        },
      };
    }

    case ActionTypes.MOVE_QUESTION_IN_GROUP: {
      const { moveDirection, sourceID, questionID } = action.payload;

      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }

      const indexEvaluatedINIT = state.groupQuestions[sourceID].question.find((q) => !q.questionID);
      const indexEvaluatedExist = state.groupQuestions[sourceID].question.find((q) =>
        q.questionID.includes('00000000_')
      );

      const fromIndex = state.groupQuestions[sourceID].question.findIndex(
        (q) => q.questionID === questionID
      );

      if (indexEvaluatedINIT && fromIndex === 1 && moveDirection === 'move_up') {
        return {
          ...state,
        };
      }
      if (indexEvaluatedExist && fromIndex === 1 && moveDirection === 'move_up') {
        return {
          ...state,
        };
      }

      if (fromIndex === 0 && moveDirection === 'move_up') {
        return {
          ...state,
        };
      }

      if (
        fromIndex === state.groupQuestions[sourceID].question.length - 1 &&
        moveDirection === 'move_down'
      ) {
        return {
          ...state,
        };
      }

      const toIndex = moveDirection === 'move_up' ? fromIndex - 1 : fromIndex + 1;

      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [sourceID]: {
            ...state.groupQuestions[sourceID],
            question: moveItemInArray(state.groupQuestions[sourceID].question, fromIndex, toIndex),
          },
        },
      };
    }

    case ActionTypes.REMOVE_QUESTION_IN_GROUP: {
      const { sourceID, questionID } = action.payload;
      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }

      const listQuestionExceptEvaluatedQuestion = state.groupQuestions[sourceID].question.filter(
        (q) => q.questionID !== questionID
      );

      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [sourceID]: {
            ...state.groupQuestions[sourceID],
            question: listQuestionExceptEvaluatedQuestion,
          },
        },
      };
    }

    case ActionTypes.UPDATE_QUESTION_EVALUATED_IN_GROUP: {
      const { sourceID, dataQuestionEvaluated } = action.payload;
      const INIT_GROUP_QUESTION = 'INIT_GROUP_QUESTION';
      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }
      const cloneState = [...state.groupQuestions[INIT_GROUP_QUESTION].question];
      const objIndex = cloneState.findIndex(
        (obj) => obj.questionTypeID === mappingSelectType.evaluated
      );
      cloneState[objIndex] = dataQuestionEvaluated;
      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [INIT_GROUP_QUESTION]: {
            ...state.groupQuestions[INIT_GROUP_QUESTION],
            question: cloneState,
          },
        },
      };
    }

    case ActionTypes.REMOVE_SECTION_IN_GROUP: {
      const { sourceID } = action.payload;
      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }

      const uuids = Object.keys(state.groupQuestions);
      const currentObjectProperties = state.groupQuestions[sourceID];
      delete state.groupQuestions[sourceID];

      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [uuids[0]]: {
            ...state.groupQuestions[uuids[0]],
            question: [
              ...state.groupQuestions[uuids[0]].question,
              ...(currentObjectProperties?.question ?? []),
            ],
          },
        },
      };
    }

    case ActionTypes.SET_SELECT_QUESTION: {
      return {
        ...state,
        selectQuestionID: action.payload.questionID,
      };
    }

    case ActionTypes.SET_SELECT_SECTION: {
      return {
        ...state,
        selectSectionID: action.payload.sectionID,
      };
    }

    case ActionTypes.EDIT_SELECT_QUESTION_IN_GROUP: {
      const { newData, questionID, sectionID } = action.payload;

      if (!state.groupQuestions) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        groupQuestions: {
          ...state.groupQuestions,
          [sectionID]: {
            ...state.groupQuestions[sectionID],
            question: [
              ...state.groupQuestions[sectionID].question.reduce<Array<CombineTypeAnswer>>(
                (prev, cur) => {
                  if (cur.questionID === questionID) {
                    return [...prev, { ...cur, ...newData }];
                  }
                  return [...prev, cur];
                },
                []
              ),
            ],
          },
        },
      };
    }

    case ActionTypes.SAVE_ALL_TABS_BEGIN: {
      return {
        ...state,
        isSaveAllTabs: true,
      };
    }

    case ActionTypes.SAVE_ALL_TABS_END: {
      return {
        ...state,
        isSaveAllTabs: false,
      };
    }

    case ActionTypes.SET_SURVEY_TAB_1_INFORMATION: {
      return {
        ...state,
        surveyInformation: action.payload.surveyInformation,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBERSEARCH: {
      return {
        ...state,
        surveyMemberSearch: action.payload.surveyMemberSearch,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBER_GROUP_FILTER: {
      return {
        ...state,
        surveyMemberGroupFilter: action.payload.surveyMemberGroupFilter,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBER_OBJECTGROUP: {
      return {
        ...state,
        memberObjectGroup: action.payload.memberObjectGroup,
      };
    }

    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST: {
      return {
        ...state,
        surveyMemberList: action.payload.surveyMemberList,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL: {
      return {
        ...state,
        surveyMemberListAll: action.payload.surveyMemberListAll,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_360: {
      return {
        ...state,
        surveyMemberList360: action.payload.surveyMemberList360,
      };
    }
    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL_360: {
      return {
        ...state,
        surveyMemberListAll360: action.payload.surveyMemberListAll360,
      };
    }

    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_SELECTED: {
      return {
        ...state,
        surveyMemberListSelected: action.payload.surveyMemberListSelected,
      };
    }

    case ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_CHOSEN: {
      return {
        ...state,
        surveyMemberListChosen: action.payload.surveyMemberListChosen,
      };
    }

    case ActionTypes.HANDLE_CHANGE_TABS: {
      return {
        ...state,
        currentTab: action.payload.typeOfTab,
      };
    }

    case ActionTypes.INIT_SURVEY: {
      return {
        ...state,
        isInitSurvey: action.payload.type === SurveyConst.START_INIT ? true : false,
      };
    }

    case ActionTypes.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload.type === SurveyConst.LOADING_ON ? true : false,
      };
    }
    case ActionTypes.SET_SAVE_TAB: {
      return {
        ...state,
        previousTab: action.payload.previousTab,
      };
    }
    case ActionTypes.SET_USER_CHANGE_MODAL_ADD_QUESTION: {
      return {
        ...state,
        isUserChangeModalAddQuestion: action.payload.isUserChangeModalAddQuestion,
      };
    }
    case ActionTypes.SET_LIST_OF_BONUS_CODE_TAB_1_INFORMATION: {
      return {
        ...state,
        listOfBonusCode: action.payload.listOfBonusCode,
      };
    }
    case ActionTypes.SET_INFO_PEOPLE: {
      return {
        ...state,
        infoPeople: action.payload.infoPeople,
      };
    }
    case ActionTypes.SET_DISABLED_SURVEY_360: {
      return {
        ...state,
        disabledSurvey360: action.payload.disabledSurvey360,
      };
    }
    case ActionTypes.SET_SURVEY_TYPE_FORM: {
      return {
        ...state,
        surveyTypeForm: action.payload.surveyTypeForm,
      };
    }
    case ActionTypes.SET_QUESTION_ID_ARR_COPY: {
      return {
        ...state,
        questionIDArrCopy: action.payload.questionIDArrCopy,
      };
    }

    case ActionTypes.SET_SURVEY_DATA_SAVE: {
      return {
        ...state,
        surveyDataSaveTab: {
          ...state.surveyDataSaveTab,
          ...action.payload.surveyDataSaveTab,
        },
      };
    }

    case ActionTypes.SET_EVALUATED_QUESTION_EXIST: {
      return {
        ...state,
        isEvaluatedQuestionExist: action.payload.isEvaluatedQuestionExist,
      };
    }

    case ActionTypes.SET_IS_COPY_SURVEY: {
      return {
        ...state,
        isCopySurvey: action.payload.isCopySurvey,
      };
    }

    case ActionTypes.SET_QUESTION_ORDER: {
      return {
        ...state,
        questionOrder: action.payload.questionOrder,
      };
    }

    case ActionTypes.SET_MEMBER_GROUP_INFO: {
      return {
        ...state,
        memberGroupInfo: action.payload.memberGroupInfo,
      };
    }

    case ActionTypes.SET_LOADING_MEMBER_GROUP_INFO: {
      return {
        ...state,
        loadingMemberGroupInfo: action.payload.loadingMemberGroupInfo,
      };
    }
    case ActionTypes.SET_TYPE_ACTION_CHANGE_LIST_MEMBER_GROUP: {
      return {
        ...state,
        typeActionChangeListMemberGroup: action.payload.typeActionChangeListMemberGroup,
      };
    }

    case ActionTypes.SET_CURRENT_VALUE_INFORMATION_TAB: {
      return {
        ...state,
        currentValueInformationTab: action.payload.surveyInformation,
      };
    }
    case ActionTypes.SET_DDL_REGION_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlRegionGroupBackup: action.payload.ddlRegionGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_UNIT_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlUnitGroupBackup: action.payload.ddlUnitGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_DEPARTMENT_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlDepartmentGroupBackup: action.payload.ddlDepartmentGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_DIVISION_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlDivisionGroupBackup: action.payload.ddlDivisionGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_RESTAURANT_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlRestaurantGroupBackup: action.payload.ddlRestaurantGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_LEVEL_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlLevelGroupBackup: action.payload.ddlLevelGroupBackup,
      };
    }
    case ActionTypes.SET_DDL_POSITION_MEMBER_GROUP_BACKUP: {
      return {
        ...state,
        ddlPositionGroupBackup: action.payload.ddlPositionGroupBackup,
      };
    }

    case ActionTypes.SET_LIST_STAFF_360: {
      return {
        ...state,
        listStaff360: action.payload.listStaff360,
      };
    }

    case ActionTypes.SET_FETCH_QUESTION_AFTER_UPLOAD_EXCEL: {
      return {
        ...state,
        isFetchQuestionAfterUploadExcel: action.payload.isFetchQuestionAfterUploadExcel,
      };
    }

    case ActionTypes.SET_PARAM_FILTERS_EVALUATED_QUESTION: {
      return {
        ...state,
        paramFiltersEvaluatedQuestion: action.payload.paramFiltersEvaluatedQuestion,
      };
    }

    case ActionTypes.SET_IS_FIRST_LOAD_TAB: {
      return {
        ...state,
        isFirstLoadTab: action.payload.isFirstLoadTab,
      };
    }
    case ActionTypes.SET_IS_MEMBER_LIST_360_CHANGED: {
      return {
        ...state,
        isMemberList360Changed: action.payload.isMemberList360Changed,
      };
    }

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
